import React, {useState} from "react";
import {Link, useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import UIUtils from "utils/UIUtils";
import KmcisLink, {KmcisConfirmResult} from "components/kmics";
import menuStore from "common/menu/store/MenuStore";

function ContentsContainer() {

    const [isAllChk, setIsAllChk] = useState(false);
    const [isChk1, setIsChk1] = useState(false);
    const [isChk2, setIsChk2] = useState(false);
    const [isChk3, setIsChk3] = useState(false);
    const [isChk4, setIsChk4] = useState(false);
    const [isChk5, setIsChk5] = useState(false);
    const [hpNo, setHpNo] = useState('gray-o');

    const history = useHistory();

    const checkBoxHandler = (e) => {

        if (e.target.name === 'ch-all') {
            setIsAllChk(e.target.checked);
            setIsChk1(e.target.checked);
            setIsChk2(e.target.checked);
            setIsChk3(e.target.checked);
            setIsChk4(e.target.checked);
            setIsChk5(e.target.checked);
        } else if (e.target.name === 'isChk1') {
            setIsChk1(e.target.checked);
        } else if (e.target.name === 'isChk2') {
            setIsChk2(e.target.checked);
        } else if (e.target.name === 'isChk3') {
            setIsChk3(e.target.checked);
        } else if (e.target.name === 'isChk4') {
            setIsChk4(e.target.checked);
        } else if (e.target.name === 'isChk5') {
            setIsChk5(e.target.checked);
        }
        if (e.target.name === 'isChk1' || e.target.name === 'isChk2' || e.target.name === 'isChk3'
                || e.target.name === 'isChk4' || e.target.name === 'isChk5'
        ) {
            let chk1 = e.target.name === 'isChk1' ? e.target.checked : isChk1;
            let chk2 = e.target.name === 'isChk2' ? e.target.checked : isChk2;
            let chk3 = e.target.name === 'isChk3' ? e.target.checked : isChk3;
            let chk4 = e.target.name === 'isChk4' ? e.target.checked : isChk4;
            let chk5 = e.target.name === 'isChk5' ? e.target.checked : isChk5;

            if (chk1 && chk2 && chk3 && chk4 && chk5) {
                setIsAllChk(true);
            } else {
                setIsAllChk(false);
            }
        }
    };

    const isChkValid = () => {

        if (!isChk1) {
            UIUtils.alert('이용약관 동의를 체크해주세요').then();
            return false;
        }

        if (!isChk2) {
            UIUtils.alert('개인정보수집 동의를 체크해주세요').then();
            return false;
        }

        if (!isChk3) {
            UIUtils.alert('개인정보 제3자 제공동의를 체크해주세요').then();
            return false;
        }

        if (!isChk4) {
            UIUtils.alert('개인정보수집 동의를 체크해주세요').then();
            return false;
        }

        if (!isChk5) {
            UIUtils.alert('개인정보수집 동의를 체크해주세요').then();
            return false;
        }

        return true;
    }

    // 취소 홈으로 이동
    const onClickCancel = () => {
        history.push({
            pathname: '/main',
            state: {data: {}}
        });
    }

    const kmcisCallback = (result: KmcisConfirmResult, confirmed: boolean) => {
        console.log("KmcisConfirmResult", result)
        let name = result?.name;
        let hpNo = result?.phoneNo;
        if (name != "") {
            let dataToSend = {name, hpNo};
            // 다른 페이지로 이동하면서 데이터 전달
            history.push({
                pathname: './usr_1202',
                state: {data: dataToSend}
            });
        } else {
            UIUtils.alert("인증이 실패했습니다.");
            return;
        }
    }

    // 넘어가기
    async function byPass() {
        let name = "홍길동";
        let hpNo = "01012341234";
        let dataToSend = {name, hpNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
            pathname: './usr_1202',
            state: {data: dataToSend}
        });

    }

    React.useEffect(() => {
        menuStore.removeCurrentMenu();
    }, [])

    return (
        <PageContainer session={false}>
            <div className='fww-con'>
                <ul className="fww-brd">
                    <li><Link to="/main/">홈</Link></li>
                    <li><Link to="#">회원가입</Link></li>
                </ul>
                <main className="fww-main" data-layout="usr">
                    <div className="member-join">
                        <h1 className="tx tx-hd2">회원가입</h1>
                        <ul className="join-step">
                            <li className="active">STEP 1. 약관동의 및 인증</li>
                            <li>STEP 2. 회원정보 입력</li>
                            <li>STEP 3. 가입완료</li>
                        </ul>
                        <section className="join-section">
                            <div className="join-top">
                                <h3 className="section-title">시스템 이용약관 동의</h3>
                                {/*
                                <label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
                                    <input name="ch-all" id="ch-all" className="ip-ch" type="checkbox"
                                           checked={isAllChk} onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">전체동의</span>
                                </label>
                                */}
                            </div>
                            <div className="terms-conts">

                                <h2>제1장 총칙</h2>
                                <br/>

                                <h3>제 1 조 (목적)</h3>
                                <p>
                                    이 약관은 대·중소기업·농어업협력재단(이하 "재단")에서 운영하는 "대·중소기업상생협력기금 종합관리시스템"의 이용 조건 및 절차에 관한 사항을 규정하는 데 있습니다.
                                </p><br/><br/>

                                <h3>제 2 조 (약관의 효력 및 변경)</h3>
                                <p>
                                    이 약관은 "재단" 홈페이지의 이용 고객에게 그 내용을 공지함으로써 효력이 발생합니다. "재단" 은 필요하다고 인정되는 경우에 이 약관을 개정할 수 있으며, 개정된 내용은 제1항과 같은 방법 으로 공지한 때로부터 그 효력이 발생합니다.
                                </p><br/><br/>

                                <h3>제 3 조 (약관적용 외 준칙)</h3>
                                <p>
                                    이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있는 경우에는 그 규정에 따릅니다.
                                </p><br/><br/>

                                <h3>제 4 조 (용어의 정의)</h3>
                                <p>
                                    이 약관에서 사용하는 용어의 정의는 다음 각호와 같습니다.<br/>
                                    1. "서비스"라 함은 "재단"에서 제공하는 제반 서비스(정보제공, 부가서비스 등)를 말합니다.<br/>
                                    2. "회원"이라 함은 "재단"과 서비스 이용계약을 체결하고 회원 ID를 부여받은 개인 또는 법인 을 말합니다.<br/>
                                    3. "이용계약"이라 함은 서비스 이용을 목적으로 "재단"과 이용자 간에 체결하는 계약을 말합니다.<br/>
                                    4. "회원 ID"라 함은 회원의 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 "재단"이 승인하는 문자와 숫자의 조합을 말합니다.<br/>
                                    5. "회원정보"라 함은 회원이 이용계약을 체결할 때 "재단"에 등록하는 회원 ID, 이름, 주소, 전화번호, 소속기업 등의 회원에 관한 정보를 말합니다.<br/>
                                    6. "비밀번호"라 함은 회원ID와 일치된 회원임을 확인하고 회원 자신의 비밀을 보호하기 위하여 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.<br/>
                                </p><br/><br/>

                                <h2>제2장 이용계약 체결</h2>
                                <br/>

                                <h3>제 5 조 (이용계약(회원가입) 체결)</h3>
                                <p>
                                    회원에 등록하여 서비스를 이용하고자 하는 자는 "재단"에서 요청하는 회원에 관한 정보를 본인이 성실하게 작성, 등록함을 원칙으로 합니다. 회원등록은 이용 희망자가 본 이용약관을 열람한
                                    후 "동의" 버튼을 누르고 다음 화면에 회원 가입신청서 양식에 따라 관련사항을 기재, "회원가입 버튼"을 누르면 이 약관에 합법적으로 동의하는 것으로 간주합니다. 이용자가 모든 사항을 성실
                                    히 기재하여 이용 신청을 완료하였을 때 "재단"이 이용 신청에 대해 승낙함으로써 계약이 체결 됩니다.
                                </p><br/><br/>

                                <h3>제 6 조 (계약 해지)</h3>
                                <p>
                                    이용자가 서비스 이용 계약을 해지하고자 하는 때에는 이용자 본인이 사전에 온라인, E-mail, 방문, 전화, 또는 팩스를 통하여 “재단”에 해지 신청을 해야 합니다.
                                    회원에게 다음 각 항에 해당하는 사유가 발생하였을 경우 "재단"은 사전 통보 없이 계약을 해지 할 수 있습니다.<br/>
                                    1. "재단"의 명예를 훼손하였을 경우<br/>
                                    2. 서비스 운영을 고의로 방해한 경우<br/>
                                    3. 타인 회원ID 및 비밀번호를 도용한 경우<br/>
                                    4. 가입 신청서를 허위로 작성한 경우<br/>
                                    5. 국익 및 사회 공익을 저해하는 행위를 계획 또는 실행한 경우<br/>
                                    6. 기타 "재단"이 회원으로서 부적합하다고 판단한 경우
                                </p><br/><br/>

                                <h2>제3장 서비스 이용</h2>
                                <br/>

                                <h3>제 7 조 (서비스 제공 및 광고의 게재)</h3>
                                <p>
                                    "재단"은 서비스의 무료 운용과 관련하여 서비스 화면, 홈페이지, 이메일 등에 광고를 게재할 수 있습니다.
                                    "재단"은 필요한 경우에는 서비스의 내용을 추가 또는 변경할 수 있습니다. 이때 "재단"은 그 내용을 사전에 공지사항으로 공시합니다.
                                </p><br/><br/>

                                <h3>제 8 조 (서비스 이용)</h3>
                                <p>
                                    서비스 이용은 "재단"의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 제공을 원칙으로 합니다. 단, 천재지변, 예산의 변경, 타 기관에 의한 사유, 시스템 점검 등 "재단"이
                                    필요한 경우 또는 시스템 장애, 서비스 이용의 폭주 등 불가항력으로 인하여 서비스를 중단할 수 있습니다. "재단"은 회원이 보다 효과적으로 활용할 수 있도록 서비스 사항에 대한 변동 내용
                                    을 공지하여야 합니다. 회원은 "재단"으로부터 검색한 자료의 지적재산권에 관한 사항과 데이터베이스 제작자가 요구하는 사항을 준수하여야 합니다.
                                </p><br/><br/>

                                <h3>제 9 조 (서비스 제공의 제한 및 중지)</h3>
                                <p>
                                    "재단"은 다음 각 호에 해당하는 경우 서비스 제공의 일부 또는 전부를 제한하거나 중지할 수 있습니다.<br/>
                                    1. 서비스용 설비의 보수, 정기점검 또는 공사로 인한 부득이한 경우<br/>
                                    2. 전기통신사업법에 규정된 기간통신 사업자가 전기통신 서비스를 중지했을 경우<br/>
                                    3. 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우<br/>
                                    4. 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우<br/>
                                    5. 제12조 회원의 의무를 현저히 위반했을 경우<br/>
                                    "재단"은 제1항의 규정에 의하여 서비스 제공의 일부 또는 전부를 제한하거나 중지 할 때에는 그 사유 및 제한기간 등을 지체 없이 공지사항이나 이메일 등을 통하여 회원에게 알립니다.
                                </p><br/><br/>

                                <h2>제4장 권리 및 의무</h2>
                                <br/>

                                <h3>제 10 조 ("재단"의 의무)</h3>
                                <p>
                                    "재단"은 이 약관 및 관계법령에 따라 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다합니다. "재단"은 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는
                                    적절한 절차를 거쳐 신속히 처리하며, 처리 기간이 지연될 경우 회원에게 지연 사유와 처리일정을 알려드립니다. "재단"은 회원이 "재단"의 서비스 제공으로부터 기대되는 이익을 얻지 못하였
                                    거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대하여는 책임을 면합니다.<br/>
                                </p><br/><br/>

                                <h3>제 11 조 (회원정보의 보호)</h3>
                                <p>
                                    "재단"은 회원의 정보를 운영하거나 개선하는 목적으로만 사용합니다.<br/>
                                    "재단"이 취득한 회원정보는 1항에 기재된 목적으로만 사용하며, 본인의 승낙 없이 제3자에게 공개하지 않습니다. "재단"은 회원정보의 보호에 최선을 다합니다.
                                </p><br/><br/>

                                <h3>제 12 조 (회원의 의무)</h3>
                                <p>
                                    회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스 상에 공지한 주의사항, "재단"이 통지하는 사항을 준수하여야 하며, 기타 "재단"의 업무에 방해되는 행위를 하여서는 아니 됩니다.
                                    회원은 서비스를 이용하여 얻은 정보를 "재단"의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공 할 수 없습니다.
                                    회원은 자신의 회원ID와 비밀번호를 유지 관리할 책임이 있으며, 자신의 회원ID와 비밀번호를 사용하여 발생하는 모든 결과에 대해 전적인 책임이 있습니다. 또한 자신의 회원ID와 비밀번호
                                    가 자신의 승낙 없이 사용되었을 경우 즉시 "재단"에 신고하여야 합니다.<br/>
                                    회원은 이용신청시의 기재내용에 대해 진실하고 정확하며 현재의 사실과 일치하도록 유지하고 갱신하여야 합니다.<br/>
                                    회원은 음란물 게재, 유포 등 사회질서를 해치는 행위, 타인의 명예를 훼손하거나 모욕하는 행위 와 타인의 지적재산권 등의 권리를 침해하는 행위를 할 수 없습니다.
                                </p><br/><br/>

                                <h2>제5장 기타</h2>
                                <br/>

                                <h3>제 13 조 ("재단"의 저작권)</h3>
                                <p>
                                    "재단"이 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타 권리는 "재단"에 소유권이 있습니다.
                                    이용자는 "재단"이 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각 재산에 대해 전부 혹은 일부 수정, 배포, 상업적 이용 행위 등을 할 수 없으며, 제3자로 하여금 이와 같은 행위를
                                    하도록 허락할 수 없습니다.
                                </p><br/><br/>

                                <h3>제 14 조 (양도금지)</h3>
                                <p>
                                    회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.
                                </p><br/><br/>

                                <h3>제 15 조 (손해배상)</h3>
                                <p>
                                    "재단"은 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경 우에는 서비스 제공에 대한 책임이 면제됩니다.<br/>
                                    "재단"은 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 책임이 면제됩니다.<br/>
                                    "재단"은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.<br/>
                                    "재단"은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지
                                    않습니다.<br/>
                                    "재단"은 서비스에 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 이용자나 제3자에 의해 표출된 의견을 승인하거나 반대하거나
                                    수정하지 않습니다.<br/>
                                    "재단"은 이용자 또는 기타 유관기관이 서비스에 게재한 정보에 대해 정확성, 신뢰도에 대하여 보장하지 않습니다. 따라서 "재단"은 이용자가 위 내용을
                                    이용함으로 인해 입게 된 모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다.<br/>
                                    "재단"은 이용자가 서비스를 이용하며 타 이용자로 인해 입게 되는 정신적 피해에 대하여 보상 할 책임을 지지 않습니다.
                                </p><br/><br/>

                                <h3>제 16 조 (관할법원)</h3>
                                <p>
                                    이 약관에 명시되지 않은 사항은 관계법령과 상관습에 따릅니다.
                                    본 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 "재단" 소재지를 관할하는 법원으로 합니다.
                                </p><br/><br/>

                                <h3>[부 칙]</h3>
                                <p>
                                    (시행일) 이 약관은 2024년 8월 1일부터 시행합니다.
                                    (경과조치) 이 약관 시행일 전부터 이용자로 등록하여 서비스를 이용하고 있는 이용자가 이 약관에 동의하지 않는 경우에는 이용자 등록을 취소하여야 합니다.
                                    만일, 이 약관 시행일로부터 3개월 이내에 회원등록을 취소하지 않는 이용자는 이 약관 내용에 동의하는 것으로 간주합니다.
                                </p><br/><br/>
                            </div>
                            <div className="join-agree">
                                <label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-1" className="ip-ch" type="checkbox" name={'isChk1'} checked={isChk1}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">동의합니다.</span>
                                </label>
                            </div>
                        </section>
                        <section className="join-section">
                            <div className="join-top">
                                <h3 className="section-title">상생협력기금 시스템 개인정보 수집 및 이용 안내</h3>
                            </div>
                            <div className="terms-conts">

                                <p>
                                    대·중소기업·농어업협력재단(이하 "재단")에서 운영하는 "대·중소기업상생협력기금 종합관리시스템 "은 귀하의 개인정보보호를 매우 중요시하며, 『정보통신망이용촉진등에관한법률』상의 개인정보보호 규정 및 정보통신부가 제정한 『개인정보보호지침』을 준수하고 있습니다. "재단"은 개인정보 보호방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
                                </p><br/>

                                <p>
                                    "재단"은 귀하께서 회원가입 시 개인정보보호정책 또는 이용약관의 내용에 대해 「동의」버튼을 클릭할 수 있는 절차를 마련하여, 「동의합니다」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.
                                </p><br/>

                                <p>"재단"은 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다. 귀하가 "재단"의 서비스를 이용하기 위해서는 회원가입 시 희망 아이디, 비밀번호, 성명, 이메일, 전화번호를 필수적으로 입력하셔야 합니다. 그러나 선택항목은 이를 입력하지 않더라도 서비스 이용에는 제한이 없습니다.
                                </p><br/>

                                <p>
                                    개인정보 항목별 구체적인 수집목적 및 이용목적은 다음과 같습니다.
                                </p><br/>

                                <p>
                                    - 성명, 아이디, 비밀번호 : 회원제 서비스 이용에 따른 본인 확인 절차에 이용<br/>
                                    - 이메일, 전화번호 : 고지사항 전달, 불만처리 등을 위한 원활한 의사소통 경로 확보, 새로운 서비스 및 이벤트 정보 안내<br/>
                                    - 기타 선택항목 : <span>대·중소기업상생협력기금 관리시스템</span>의 원활한 사용을 위해 부수적으로 필요한 정보
                                </p><br/>

                                <p>
                                    귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 [마이페이지]를 클릭하여 직접 열람 또는 정정하거나, 개인정보관리책임자에게 (서면, 전화, E-mail)로 연락하시면 즉시 조치하겠습니다.
                                    귀하가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다.
                                    또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 조치하겠습니다. 회원가입 등을 통해 이루어진 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회하실 수 있습니다. 동의철회는 개인정보관리책임자에게 (서면, 전화, E- mail)로 연락하시면 즉시 개인정보의 삭제 등 필요한 조치를 취하겠습니다.
                                </p><br/>

                                <p>
                                    수집된 개인정보의 보유기간은 회원가입 후 회원탈퇴시까지 입니다. 또한 탈퇴 시 "재단"은 회원님의 개인정보를 재생이 불가능한 방법으로 즉시 파기하며 (개인정보가 제3자에게 제공된 경우에는 제3자에게도 파기하도록 지시합니다.) 다만, 다음 각 호의 경우에는 각 호에 명시한 기간 동안 개인정보를 보유합니다.
                                </p><br/>

                                <p>
                                    ① 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간동안 거래내역과 최소한의 기본정보를 보유<br/>
                                    ② 보유기간을 회원님에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 회원님의 동의를 받을 경우에는 약속한 보유기간 동안<br/>
                                    ③ 계약 또는 청약철회 등에 관한 기록은 5년, 대금결제 및 재화 등의 공급에 관한 기록은 5년, 그리고 소비자의 불만 또는 분쟁처리에 관한 기록은 3년 동안. 귀하의 동의를 받아 보유하고 있는 거래정보 등을 귀하께서 열람을 요구하는 경우 "재단"은 지체 없이 그 열람, 확인할 수 있도록 조치합니다.<br/>
                                    "재단"은 귀하의 개인정보를 [개인정보의 수집목적 및 이용목적]에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타 기업·기관에 제공하지 않습니다. 그러나 보다나은 서비스 제공을 위하여 귀하의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다.
                                    개인 정보를 제공하거나 공유할 경우에는 사전에 귀하께 제휴사가 누구인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지, 그리고 언제까지 어떻게 보호·관리되는지에 대해 개별적으로 전자우편 및 서면을 통해 고지하여 동의를 구하는 절차를 거치게 되며, 귀하께서 동의하지 않는 경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다
                                </p><br/>

                                <p>
                                    "재단"은 현재 회원의 개인정보를 "재단" 자체적으로 처리하고 있습니다. 그러나 향상된 서비스의 제공을 위해서 귀하의 개인정보를 외부에 위탁하여 처리할 수 있습니다. 개인정보의 처리를 위탁하는 경우에는 미리 그 사실을 귀하에게 고지하겠습니다.
                                </p><br/>

                                <p>
                                    개인정보의 처리를 위탁하는 경우에는 위탁계약 등을 통하여 서비스제공자의 개인정보보호 관련 지시 엄수, 개인정보에 관한 비밀유지, 제3자 제공의 금지 및 사고시의 책임부담 등을 명확히 규정하고 당해 계약내용을 서면 또는 전자적으로 보관하겠습니다.
                                </p><br/>

                                <p>
                                    "재단"은 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
                                </p><br/>

                                <p>
                                    ① 귀하의 개인정보는 비밀번호에 의해 보호되며, 비밀번호는 암호알고리즘을 이용하여 안전하게 보호되고 있습니다.<br/>
                                    ② 해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며, 각 서버마다 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.<br/>
                                    귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 "재단"은 개인정보보호 담당자를 두어 귀하의 개인 정보를 관리하고 있으며 개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 운영하고 있습니다.
                                    귀하의 개인정보와 관련한 문의사항 및 불만 사항이 있으시면 아래의 개인정보보호 담당자에게 연락 주시면 즉시 조치하여 처리결과를 통보 하겠습니다.
                                </p><br/>

                                <p>
                                    <strong>
                                        대중소기업상생협력기금 종합관리시스템<br/>
                                        개인정보 담당자 : 대·중소기업·농어업협력재단 상생기금부 김주경 차장 (kjk@win-win.or.kr, 02-368-8713)<br/>
                                        개인정보보호책임자 : 형준호 본부장<br/>
                                        소 속 : 대·중소기업·농어업협력재단·기획조정본부<br/>
                                    </strong>
                                    정보주체는 다음 각 호의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.
                                    개인정보보호위원회의 자체적인 개인정보 불만처리, 피해구제를 통해 해결되지 않으시거나 보다 자세한 도움이 필요하시면 아래의 기관으로 문의하여 주시기 바랍니다.
                                </p><br/>

                                <p>
                                    1. 개인정보 분쟁조정위원회<br/>
                                    가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)<br/>
                                    나. 홈페이지 : <a href="http://www.kopico.go.kr"
                                                 target="_blank">www.kopico.go.kr</a><br/>
                                    다. 전화 : (국번없이)1833-6972<br/>
                                    라. 주소 : (03171) 서울특별시 종로구 세종대로 209 정부서울청사 12층<br/>

                                    2. 개인정보 침해신고센터 (한국인터넷진흥원 운영)<br/>
                                    가. 소관업무 : 개인정보 침해사실 신고, 상담 신청<br/>
                                    나. 홈페이지 : <a href="http://privacy.kisa.or.kr" target="_blank">privacy.kisa.or.kr</a><br/>
                                    다. 전화 : (국번없이) 118<br/>
                                    3. 대검찰청 사이버수사과 : (국번없이) 1301 ( <a href="http://www.spo.go.kr"
                                                                      target="_blank">www.spo.go.kr</a>)<br/>
                                    4. 경찰청 사이버안전국 : (국번없이) 182 (<a
                                    href="https://cyberbureau.police.go.kr/prevention/sub4_4.jsp?mid=020505"
                                    target="_blank">https://cyberbureau.police.go.kr</a>)<br/>
                                    이 개인정보 처리방침은 2024년 8월 1일부터 적용됩니다.
                                </p><br/>

                                <p>
                                    법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전에 홈 페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다.
                                </p><br/>
                            </div>
                            <div className="join-agree">
                                <label htmlFor="ch-2" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-2" className="ip-ch" type="checkbox" name={'isChk2'} checked={isChk2}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">동의합니다.</span>
                                </label>
                            </div>
                        </section>
                        <section className="join-section">
                            <div className="join-top">
                                <h3 className="section-title">개인정보 제3자 제공동의</h3>
                            </div>
                            <div className="terms-conts">
                                <p>
                                    상생협력기금 활용 사업과 관련하여 귀 대·중소기업·농어업협력재단이 본인의 기업(신용)정보를 수집․이용하거나 제3자에게 제공하고자 하는 경우에는
                                    「개인정보보호법」 제15조제1항제1호, 제 17조제1항제1호, 제23조제1호, 제24조제1항제1호 및 「신용정보의 이용 및 보호에 관한 법률」
                                    제 32조제1항, 제33조, 제34조에 따라 본인의 동의를 얻어야 합니다. 이에 본인은 아래의 내용과 같이 대·중소기업·농어업협력재단이 본인의
                                    기업(신용)정보를 수집․이용 또는 제공하는 것에 동의합니다.
                                </p><br/>
                                <p>
                                    1. 신용상태 조회동의<br/>
                                    본인은 상생협력기금 활용과 관련한 재무건전성 등의 확인을 위하여 대·중소기업·농어업협력재단이 필요하다고 판단되는 경우 신용상태를 조회함에 동의합니다.
                                </p><br/>
                                <p>
                                    2. 정보제공 및 활용동의<br/>
                                    기업정보의 확인 및 통계관리를 위하여 대·중소기업·농어업협력재단에 제출한 기업정보의 활용에 동의하며, 대·중소기업·농어업협력재단에 보유자료가 없을
                                    시에는 중소기업청 또는 전문기관에서 지정한 기관에 관련자료 제출 및 갱신에 성실히 임할 것을 동의합니다.
                                    [상생협력기금 시스템 개인정보 제3자 제공 동의(회원가입시)]
                                </p><br/>
                                <p>
                                    상생협력기금 시스템은 상생협력기금 활용 사업관리를 목적으로 아래와 같이 개인정보를 제3자에게 제공하고자 합니다.
                                </p><br/>
                                <p>
                                    내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
                                </p><br/>
                                <p>
                                    □ 개인정보 제3자 제공 내역
                                </p><br/>

                                <div className="tb">
                                    <table>
                                        <caption></caption>
                                        <colgroup>
                                            <col width="200px"/>
                                            <col width="300px"/>
                                            <col width="200px"/>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>제공받는 기관</th>
                                            <th>제공목적</th>
                                            <th>제공하는 항목</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>대·중소기업·농어업협력재단 상위부처 및 관련기업·단체(제휴사)</td>
                                            <td>상생협력기금 제도활성화 등을 위한 기업 담당자 안내 및 관련 세부사항 확인</td>
                                            <td>이름, 기업명, 연락처(전화번호, 이메일)</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br/>

                                <p>
                                    ※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다.
                                </p>
                                <p>
                                    그러나 동의를 거부할 경우 원활한 서비스 제공에 일부 제한을 받을 수 있습니다.
                                </p>

                            </div>
                            <div className="join-agree">
                                <label htmlFor="ch-3" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-3" className="ip-ch" type="checkbox" name={'isChk3'} checked={isChk3}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">동의합니다.</span>
                                </label>
                            </div>
                        </section>
                        <section className="join-section">
                            <div className="join-top">
                                <h3 className="section-title">기업 신용정보상태 및 조회 동의서 필수 여부</h3>
                            </div>
                            <div className="terms-conts">

                                <p>
                                    상생협력기금 활용 사업과 관련하여 귀 대·중소기업·농어업협력재단이 본인의 기업(신용)정보를 수집․이용하거나 제3자에게 제공하고자 하는
                                    경우에는「개인정보보호법」제15조제1항제1호, 제17조제1항제1호, 제23조제1호, 제24조제1항제1호 및「신용정보의 이용 및 보호에 관한
                                    법률」제32조제1항, 제33조, 제34조에 따라 본인의 동의를 얻어야 합니다. 이에 본인은 아래의 내용과 같이 대·중소기업·농어업협력재단이 본인의
                                    기업(신용)정보를 수집․이용 또는 제공하는 것에 동의합니다.
                                </p><br/>

                                <p>
                                    1. 신용상태 조회동의 <br/>
                                    본인은 상생협력기금 활용과 관련한 재무건전성의 확인을 위하여 대·중소기업·농어업협력재단이 필요하다고 판단되는 경우 신용상태를 조회함에 동의합니다.
                                </p><br/>

                                <p>
                                    2. 정보제공 및 활용동의 <br/>
                                    기업정보의 확인 및 통계관리를 위하여 대·중소기업·농어업협력재단에 제출한 기업정보의 활용에 동의하며, 대·중소기업·농어업협력재단에 보유자료가 없을
                                    시에는 중소기업청 또는 전문기관에서 지정한 기관에 관련자료 제출 및 갱신에 성실히 임할 것을 동의합니다.
                                </p><br/>

                            </div>
                            <div className="join-agree">
                                <label htmlFor="ch-4" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-4" className="ip-ch" type="checkbox" name={'isChk4'} checked={isChk4}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">동의합니다.</span>
                                </label>
                            </div>
                        </section>
                        <section className="join-section">
                            <div className="join-top">
                                <h3 className="section-title">청렴실천 동의 서약서</h3>
                            </div>
                            <div className="terms-conts">

                                <p>
                                    상생협력법 제20조의5에 따른 대·중소기업 상생협력기금 출연·사용 등과 관련하여, 다음과 같이 청렴하게 업무를 수행할 것을 서약합니다.
                                </p><br/>

                                <p>
                                    하나, 나는 관련법률과 규정 등 원칙을 준수하며 청렴문화 조성에 앞장선다.
                                </p>

                                <p>
                                    하나, 나는 어떠한 부정청탁도 하거나 받지 않지않는다.
                                </p>

                                <p>
                                    하나, 나는 어떠한 경우에도 금품·향응을 제공하거나, 받지 않으며, 공정성과 청렴성을 의심받을만한 일체의 행동을 하지 않는다.
                                </p>

                                <p>
                                    하나, 나는 사적 이해관계에 영향을 받지 아니하고 직무를 공정하고 청렴하게 수행한다.
                                </p><br/>

                                <p>
                                    만약 위 사항을 위반하였을 경우엔 어떠한 처벌이나 불이익도 감수할 것에 다짐합니다.
                                </p>


                            </div>
                            <div className="join-agree">
                                <label htmlFor="ch-5" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-5" className="ip-ch" type="checkbox" name={'isChk5'} checked={isChk5}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">동의합니다.</span>
                                </label>
                            </div>
                        </section>

                        <div className="ta-center mb50">
                            <label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
                                    <input name="ch-all" id="ch-all" className="ip-ch" type="checkbox"
                                           checked={isAllChk}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt fs18">위의 사항에 대하여 전체동의합니다.</span>
                                </label>
                        </div>

                        <div className="certification">
                            <h3>본인 인증 확인</h3>
                            <ul className="list-group">
                                <li>이용자의 개인정보 보호를 위해 본인확인 절차가 필요합니다.</li>
                                <li>정보통신망(2012.08.18 시행) 제23조 2(주민번호 사용제한) 규정에 따라 온라인 상 주민번호의 수집/이용을 제한합니다.</li>
                                <li>입력하신 정보는 본인확인 용도 외 사용되거나 저장되지 않습니다.</li>
                            </ul>
                        </div>
                        <div className="hz-root hz-center hz-gap10">
                            <Button color='gray-o' size="big" onClick={onClickCancel}>취소</Button>
                            <KmcisLink color={isAllChk == true ? `pri` : 'gray-o'} size={`big`} className={`bt`}
                                       urlCodeType={`1`}
                                       preCheck={isChkValid}
                                       callback={kmcisCallback}>
                                휴대폰 인증하기
                            </KmcisLink>
                            {/*<Button color='pri' size="md" onClick={() => byPass()}>넘어가기</Button>*/}
                        </div>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}

export default ContentsContainer;